import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import type { ChecklistDraftEntry } from '../fm-work-order-checklist.util';
import type { WoChecklistDraftsStored } from './wo-offline.models';

const KEY_PREFIX = 'wo_checklist_drafts_v1:';

@Injectable({ providedIn: 'root' })
export class WoChecklistDraftStoreService {
  private key(workOrderId: number): string {
    return `${KEY_PREFIX}${workOrderId}`;
  }

  async save(
    workOrderId: number,
    organizationId: number,
    projectId: number,
    drafts: Record<number, ChecklistDraftEntry>,
  ): Promise<void> {
    const payload: WoChecklistDraftsStored = {
      workOrderId,
      organizationId,
      projectId,
      updatedAt: new Date().toISOString(),
      drafts,
    };
    await Preferences.set({ key: this.key(workOrderId), value: JSON.stringify(payload) });
  }

  async load(workOrderId: number): Promise<WoChecklistDraftsStored | null> {
    const { value } = await Preferences.get({ key: this.key(workOrderId) });
    if (!value) {
      return null;
    }
    try {
      return JSON.parse(value) as WoChecklistDraftsStored;
    } catch {
      return null;
    }
  }

  async clear(workOrderId: number): Promise<void> {
    await Preferences.remove({ key: this.key(workOrderId) });
  }
}
